import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import surgeryImage from '../../assets/surgeryImage.jpg';

const Styles = styled.div`
    .jumbo { 
        background: url(${surgeryImage}) fixed bottom;
        background-size: cover;
        color: #efefef;
        height: 180px;
        position: relative;
        z-index: -2;
    }

    .overlay {
        background-color: #000;
        opacity: 0.6;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

export const Jumbotron = () => (
    <Styles>
        <Jumbo fluid className="jumbo">
            <div className="overlay"></div>
            <Container>
                <h1>Welcome</h1>
                <p>To Multi-Agent Management of Soroka's Operating rooms</p>
            </Container>
        </Jumbo>
    </Styles>
)